import React from 'react'
import './Title.css'
import { Col } from "reactstrap"

        const title = (props) => {
    const titleClass = props.isActive ? "ActiveTitle" : "Title"
    const chooseTitle = () => {
        props.chooseTitle(props.title.id)
    }
    return (
            <div className="small-faq-cols">
                <div className={titleClass} onClick={chooseTitle}>
                    {props.title.description}
                </div>
            </div>
            )
}

export default title